DR.roadgames = DR.roadgames || {};
DR.roadgames.struct = DR.roadgames.struct || {};
DR.roadgames.select = DR.roadgames.select || {};
/** @extends {DR._Base} */
DR.roadgames.struct.EventContentLanguage = function(par){
	/** @private */
	this._t = 1317;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.caption)) this.caption = String(par.caption||'');
	if(DR._Base.is(par.language)) this.language = String(par.language||'');
};
DR._Base._types[1317] = DR.roadgames.struct.EventContentLanguage;
DR.roadgames.struct.EventContentLanguage[__P] = new DR._Base;
DR.roadgames.struct.EventContentLanguage[__P][__C] = DR.roadgames.struct.EventContentLanguage;
/** @type {String} */
DR.roadgames.struct.EventContentLanguage.prototype.caption = null;
/** @type {String} */
DR.roadgames.struct.EventContentLanguage.prototype.language = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.Image = function(par){
	/** @private */
	this._t = 1001;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.h)) this.h = (parseInt(par.h)||0);
	if(DR._Base.is(par.large)) this.large = String(par.large||'');
	if(DR._Base.is(par.medium)) this.medium = String(par.medium||'');
	if(DR._Base.is(par.original)) this.original = String(par.original||'');
	if(DR._Base.is(par.small)) this.small = String(par.small||'');
	if(DR._Base.is(par.w)) this.w = (parseInt(par.w)||0);
};
DR._Base._types[1001] = DR.roadgames.struct.Image;
DR.roadgames.struct.Image[__P] = new DR._Base;
DR.roadgames.struct.Image[__P][__C] = DR.roadgames.struct.Image;
/** @type {Number} */
DR.roadgames.struct.Image.prototype.h = null;
/** @type {String} */
DR.roadgames.struct.Image.prototype.large = null;
/** @type {String} */
DR.roadgames.struct.Image.prototype.medium = null;
/** @type {String} */
DR.roadgames.struct.Image.prototype.original = null;
/** @type {String} */
DR.roadgames.struct.Image.prototype.small = null;
/** @type {Number} */
DR.roadgames.struct.Image.prototype.w = null;
 
/** @extends {DR._Select} */
DR.roadgames.select.Image = function(){
	this._fields = {};
};
DR.roadgames.select.Image[__CL] = "Roadgames__Image";
DR.roadgames.select.Image[__P] = new DR._Select;
DR.roadgames.select.Image[__P][__C] = DR.roadgames.select.Image;
/** @param {boolean} [v]
  * @return {DR.roadgames.select.Image} */
DR.roadgames.select.Image.prototype.h = function(v){ this._fields.h = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.roadgames.select.Image} */
DR.roadgames.select.Image.prototype.large = function(v){ this._fields.large = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.roadgames.select.Image} */
DR.roadgames.select.Image.prototype.medium = function(v){ this._fields.medium = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.roadgames.select.Image} */
DR.roadgames.select.Image.prototype.original = function(v){ this._fields.original = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.roadgames.select.Image} */
DR.roadgames.select.Image.prototype.small = function(v){ this._fields.small = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.roadgames.select.Image} */
DR.roadgames.select.Image.prototype.w = function(v){ this._fields.w = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.roadgames.struct.AppVersion = function(par){
	/** @private */
	this._t = 1093;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.forceUpdate)) this.forceUpdate = Boolean(par.forceUpdate);
	if(DR._Base.is(par.hasUpdate)) this.hasUpdate = Boolean(par.hasUpdate);
	if(DR._Base.is(par.latestVersion)) this.latestVersion = String(par.latestVersion||'');
	if(DR._Base.is(par.minVersion)) this.minVersion = String(par.minVersion||'');
};
DR._Base._types[1093] = DR.roadgames.struct.AppVersion;
DR.roadgames.struct.AppVersion[__P] = new DR._Base;
DR.roadgames.struct.AppVersion[__P][__C] = DR.roadgames.struct.AppVersion;
/** @type {Boolean} */
DR.roadgames.struct.AppVersion.prototype.forceUpdate = null;
/** @type {Boolean} */
DR.roadgames.struct.AppVersion.prototype.hasUpdate = null;
/** @type {String} */
DR.roadgames.struct.AppVersion.prototype.latestVersion = null;
/** @type {String} */
DR.roadgames.struct.AppVersion.prototype.minVersion = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.CheckCodeRe = function(par){
	/** @private */
	this._t = 1219;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.event)) this.event = DR._Base.cast(par.event);
	if(DR._Base.is(par.needAuth)) this.needAuth = Boolean(par.needAuth);
	if(DR._Base.is(par.needConfirmation)) this.needConfirmation = Boolean(par.needConfirmation);
	if(DR._Base.is(par.team)) this.team = DR._Base.cast(par.team);
	if(DR._Base.is(par.user)) this.user = DR._Base.cast(par.user);
	if(DR._Base.is(par.validFor)) this.validFor = String(par.validFor||'');
};
DR._Base._types[1219] = DR.roadgames.struct.CheckCodeRe;
DR.roadgames.struct.CheckCodeRe.VALIDFOR_TEAM = "team";
DR.roadgames.struct.CheckCodeRe.VALIDFOR_EVENT = "event";
DR.roadgames.struct.CheckCodeRe.VALIDFOR_TEAMUSER = "teamUser";
DR.roadgames.struct.CheckCodeRe.VALIDFOR_EVENTUSER = "eventUser";
DR.roadgames.struct.CheckCodeRe.VALIDFOR_DISCOUNT = "discount";
DR.roadgames.struct.CheckCodeRe[__P] = new DR._Base;
DR.roadgames.struct.CheckCodeRe[__P][__C] = DR.roadgames.struct.CheckCodeRe;
/** @type {DR.events.struct.Event|null} */
DR.roadgames.struct.CheckCodeRe.prototype.event = null;
/** @type {Boolean} */
DR.roadgames.struct.CheckCodeRe.prototype.needAuth = null;
/** @type {Boolean} */
DR.roadgames.struct.CheckCodeRe.prototype.needConfirmation = null;
/** @type {DR.teams.struct.Team|null} */
DR.roadgames.struct.CheckCodeRe.prototype.team = null;
/** @type {DR.users.struct.AuthRe|null} */
DR.roadgames.struct.CheckCodeRe.prototype.user = null;
/** @type {String} */
DR.roadgames.struct.CheckCodeRe.prototype.validFor = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.AuthorizedUrl = function(par){
	/** @private */
	this._t = 1119;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
};
DR._Base._types[1119] = DR.roadgames.struct.AuthorizedUrl;
DR.roadgames.struct.AuthorizedUrl[__P] = new DR._Base;
DR.roadgames.struct.AuthorizedUrl[__P][__C] = DR.roadgames.struct.AuthorizedUrl;
/** @type {String} */
DR.roadgames.struct.AuthorizedUrl.prototype.url = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.EventContentLanguages = function(par){
	/** @private */
	this._t = 1318;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.languages)){
		var tmp = [];
		for( var k in par.languages ) tmp.push(DR._Base.cast(par.languages [k]));
		this.languages = tmp;
	}
};
DR._Base._types[1318] = DR.roadgames.struct.EventContentLanguages;
DR.roadgames.struct.EventContentLanguages[__P] = new DR._Base;
DR.roadgames.struct.EventContentLanguages[__P][__C] = DR.roadgames.struct.EventContentLanguages;
/** @type {Array.<DR.roadgames.struct.EventContentLanguage>} */
DR.roadgames.struct.EventContentLanguages.prototype.languages = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.WebRules = function(par){
	/** @private */
	this._t = 1211;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.data)) this.data = String(par.data||'');
	if(DR._Base.is(par.html)) this.html = String(par.html||'');
};
DR._Base._types[1211] = DR.roadgames.struct.WebRules;
DR.roadgames.struct.WebRules[__P] = new DR._Base;
DR.roadgames.struct.WebRules[__P][__C] = DR.roadgames.struct.WebRules;
/** @type {String|null} */
DR.roadgames.struct.WebRules.prototype.data = null;
/** @type {String|null} */
DR.roadgames.struct.WebRules.prototype.html = null;
 
/** @extends {DR._Select} */
DR.roadgames.select.WebRules = function(){
	this._fields = {};
};
DR.roadgames.select.WebRules[__CL] = "Roadgames__WebRules";
DR.roadgames.select.WebRules[__P] = new DR._Select;
DR.roadgames.select.WebRules[__P][__C] = DR.roadgames.select.WebRules;
/** @param {boolean} [v]
  * @return {DR.roadgames.select.WebRules} */
DR.roadgames.select.WebRules.prototype.data = function(v){ this._fields.data = !DR._Base.is(v) || !!v; return this; };
/** @param {boolean} [v]
  * @return {DR.roadgames.select.WebRules} */
DR.roadgames.select.WebRules.prototype.html = function(v){ this._fields.html = !DR._Base.is(v) || !!v; return this; };
 
/** @extends {DR._Base} */
DR.roadgames.struct.Pic = function(par){
	/** @private */
	this._t = 1023;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.image)) this.image = DR._Base.cast(par.image);
	if(DR._Base.is(par.type)) this.type = Number(par.type);
};
DR._Base._types[1023] = DR.roadgames.struct.Pic;
DR.roadgames.struct.Pic.TYPE_TMP = 1;
DR.roadgames.struct.Pic.TYPE_USER = 2;
DR.roadgames.struct.Pic.TYPE_EVENT = 3;
DR.roadgames.struct.Pic.TYPE_TEAM = 4;
DR.roadgames.struct.Pic.TYPE_IMAGEMATCH = 5;
DR.roadgames.struct.Pic.TYPE_CRAZYWOLF = 6;
DR.roadgames.struct.Pic.TYPE_EVENTREGION = 7;
DR.roadgames.struct.Pic.TYPE_EVENTGALLERY = 8;
DR.roadgames.struct.Pic.TYPE_USERCONTENTPLACE = 9;
DR.roadgames.struct.Pic.TYPE_USERCONTENTOBJECT = 10;
DR.roadgames.struct.Pic.TYPE_USERCONTENTLOCATION = 11;
DR.roadgames.struct.Pic.TYPE_CHAT = 12;
DR.roadgames.struct.Pic.TYPE_EVENTIMAGE = 13;
DR.roadgames.struct.Pic.TYPE_IMAGEMATCHUPDATE = 14;
DR.roadgames.struct.Pic.TYPE_TREASURE = 15;
DR.roadgames.struct.Pic.TYPE_TREASURELOGO = 16;
DR.roadgames.struct.Pic.TYPE_OBJECTPICTURE = 17;
DR.roadgames.struct.Pic.TYPE_BLOGIMAGE = 18;
DR.roadgames.struct.Pic.TYPE_NOTIFICATIONICON = 19;
DR.roadgames.struct.Pic.TYPE_TREASURENOTIFICATION = 20;
DR.roadgames.struct.Pic.TYPE_DETECTIVECLUE = 21;
DR.roadgames.struct.Pic.TYPE_CRAZYWOLFTASK = 22;
DR.roadgames.struct.Pic.TYPE_TOOLTIP = 23;
DR.roadgames.struct.Pic.TYPE_CRAZYWOLFCONSENT = 24;
DR.roadgames.struct.Pic.TYPE_EVENTLANDING = 25;
DR.roadgames.struct.Pic.TYPE_OBJECTPLAYERFEEDBACK = 26;
DR.roadgames.struct.Pic.TYPE_CHATENDMESSAGE = 27;
DR.roadgames.struct.Pic.TYPE_EVENTSTART = 28;
DR.roadgames.struct.Pic.TYPE_HOMEPAGEQUOTE = 29;
DR.roadgames.struct.Pic.TYPE_HOMEPAGECASESTUDY = 30;
DR.roadgames.struct.Pic.TYPE_HOMEPAGECASESTUDYLOGO = 31;
DR.roadgames.struct.Pic.TYPE_GOLDDIGGERTEXT = 32;
DR.roadgames.struct.Pic.TYPE_OBJECTNEWIMAGE = 33;
DR.roadgames.struct.Pic.TYPE_EVENTPARTNER = 34;
DR.roadgames.struct.Pic.TYPE_EVENTSPONSOR = 35;
DR.roadgames.struct.Pic.TYPE_BLOGCOVER = 36;
DR.roadgames.struct.Pic.TYPE_OBJECTNEWIMAGECLOSEUP = 37;
DR.roadgames.struct.Pic.TYPE_BLOGAUTHOR = 38;
DR.roadgames.struct.Pic.TYPE_EVENTLANDINGMOBILE = 39;
DR.roadgames.struct.Pic.TYPE_INSTAGRAMFEED = 40;
DR.roadgames.struct.Pic.TYPE_IMAGEVARIANT = 41;
DR.roadgames.struct.Pic.TYPE_MEDIALIBRARY = 42;
DR.roadgames.struct.Pic.TYPE_RESULTSSHARE = 43;
DR.roadgames.struct.Pic.TYPE_RESULTSSHAREMAP = 44;
DR.roadgames.struct.Pic.TYPE_CASESTUDIESIMAGE = 45;
DR.roadgames.struct.Pic.TYPE_CASESTUDIESCOVER = 46;
DR.roadgames.struct.Pic.TYPE_CASESTUDIESCOVERMOBILE = 47;
DR.roadgames.struct.Pic.TYPE_POPUPBANNERS = 48;
DR.roadgames.struct.Pic[__P] = new DR._Base;
DR.roadgames.struct.Pic[__P][__C] = DR.roadgames.struct.Pic;
/** @type {Number} */
DR.roadgames.struct.Pic.prototype.id = null;
/** @type {DR.roadgames.struct.Image} */
DR.roadgames.struct.Pic.prototype.image = null;
/** @type {Number} */
DR.roadgames.struct.Pic.prototype.type = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.Video = function(par){
	/** @private */
	this._t = 1039;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.height)) this.height = (parseInt(par.height)||0);
	if(DR._Base.is(par.id)) this.id = (parseInt(par.id)||0);
	if(DR._Base.is(par.isReady)) this.isReady = Boolean(par.isReady);
	if(DR._Base.is(par.thumbnail)) this.thumbnail = DR._Base.cast(par.thumbnail);
	if(DR._Base.is(par.tmpId)) this.tmpId = (parseInt(par.tmpId)||0);
	if(DR._Base.is(par.tmpUrl)) this.tmpUrl = String(par.tmpUrl||'');
	if(DR._Base.is(par.type)) this.type = Number(par.type);
	if(DR._Base.is(par.url)) this.url = String(par.url||'');
	if(DR._Base.is(par.width)) this.width = (parseInt(par.width)||0);
};
DR._Base._types[1039] = DR.roadgames.struct.Video;
DR.roadgames.struct.Video.TYPE_CRAZYWOLF = 1;
DR.roadgames.struct.Video.TYPE_CRAZYWOLFTASK = 2;
DR.roadgames.struct.Video.TYPE_EVENTSTART = 3;
DR.roadgames.struct.Video.TYPE_EVENTLANDING = 4;
DR.roadgames.struct.Video.TYPE_EVENTLANDINGMOBILE = 5;
DR.roadgames.struct.Video[__P] = new DR._Base;
DR.roadgames.struct.Video[__P][__C] = DR.roadgames.struct.Video;
/** @type {Number} */
DR.roadgames.struct.Video.prototype.height = null;
/** @type {Number|null} */
DR.roadgames.struct.Video.prototype.id = null;
/** @type {Boolean} */
DR.roadgames.struct.Video.prototype.isReady = null;
/** @type {DR.roadgames.struct.Image} */
DR.roadgames.struct.Video.prototype.thumbnail = null;
/** @type {Number|null} */
DR.roadgames.struct.Video.prototype.tmpId = null;
/** @type {String|null} */
DR.roadgames.struct.Video.prototype.tmpUrl = null;
/** @type {Number} */
DR.roadgames.struct.Video.prototype.type = null;
/** @type {String} */
DR.roadgames.struct.Video.prototype.url = null;
/** @type {Number} */
DR.roadgames.struct.Video.prototype.width = null;
 
/** @extends {DR._Method} */
DR.roadgames.CheckAppVersion = function(par){
	this.select = [];
	/** @private */
	this._t = 1094;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1094] = DR.roadgames.CheckAppVersion;
DR.roadgames.CheckAppVersion[__CL] = "Roadgames__CheckAppVersion";
DR.roadgames.CheckAppVersion[__P] = new DR._Method;
DR.roadgames.CheckAppVersion[__P][__C] = DR.roadgames.CheckAppVersion;
/** @type {String} */
DR.roadgames.CheckAppVersion.prototype.version = null;
/** @type {DR.roadgames.struct.AppVersion} */
DR.roadgames.CheckAppVersion.prototype.re = null;
 
/** @extends {DR._Method} */
DR.roadgames.CheckCode = function(par){
	this.select = [];
	/** @private */
	this._t = 1220;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1220] = DR.roadgames.CheckCode;
DR.roadgames.CheckCode[__CL] = "Roadgames__CheckCode";
DR.roadgames.CheckCode[__P] = new DR._Method;
DR.roadgames.CheckCode[__P][__C] = DR.roadgames.CheckCode;
/** @type {String} */
DR.roadgames.CheckCode.prototype.code = null;
/** @type {Boolean|null} */
DR.roadgames.CheckCode.prototype.forceJoin = null;
/** @type {DR.roadgames.struct.CheckCodeRe} */
DR.roadgames.CheckCode.prototype.re = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.Coordinates = function(par){
	/** @private */
	this._t = 1006;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.latitude)) this.latitude = (parseFloat(par.latitude)||0);
	if(DR._Base.is(par.longitude)) this.longitude = (parseFloat(par.longitude)||0);
};
DR._Base._types[1006] = DR.roadgames.struct.Coordinates;
DR.roadgames.struct.Coordinates[__P] = new DR._Base;
DR.roadgames.struct.Coordinates[__P][__C] = DR.roadgames.struct.Coordinates;
/** @type {Number} */
DR.roadgames.struct.Coordinates.prototype.latitude = null;
/** @type {Number} */
DR.roadgames.struct.Coordinates.prototype.longitude = null;
 
/** @extends {DR._Method} */
DR.roadgames.GetAuthorizedUrl = function(par){
	this.select = [];
	/** @private */
	this._t = 1120;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1120] = DR.roadgames.GetAuthorizedUrl;
DR.roadgames.GetAuthorizedUrl[__CL] = "Roadgames__GetAuthorizedUrl";
DR.roadgames.GetAuthorizedUrl[__P] = new DR._Method;
DR.roadgames.GetAuthorizedUrl[__P][__C] = DR.roadgames.GetAuthorizedUrl;
/** @type {String} */
DR.roadgames.GetAuthorizedUrl.prototype.url = null;
/** @type {DR.roadgames.struct.AuthorizedUrl} */
DR.roadgames.GetAuthorizedUrl.prototype.re = null;
 
/** @extends {DR._Method} */
DR.roadgames.GetEventContentLanguages = function(par){
	this.select = [];
	/** @private */
	this._t = 1319;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1319] = DR.roadgames.GetEventContentLanguages;
DR.roadgames.GetEventContentLanguages[__CL] = "Roadgames__GetEventContentLanguages";
DR.roadgames.GetEventContentLanguages[__P] = new DR._Method;
DR.roadgames.GetEventContentLanguages[__P][__C] = DR.roadgames.GetEventContentLanguages;
/** @type {DR.roadgames.struct.EventContentLanguages} */
DR.roadgames.GetEventContentLanguages.prototype.re = null;
 
/** @extends {DR._Method} */
DR.roadgames.GetWebRules = function(par){
	this.select = [];
	/** @private */
	this._t = 1212;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.re)) this.re = DR._Base.cast(par.re);
	if(DR._Base.is(par.error)) this.error = par.error;
};
DR._Base._types[1212] = DR.roadgames.GetWebRules;
DR.roadgames.GetWebRules[__CL] = "Roadgames__GetWebRules";
DR.roadgames.GetWebRules.LANGUAGE_LV = "lv";
DR.roadgames.GetWebRules.LANGUAGE_EN = "en";
DR.roadgames.GetWebRules.LANGUAGE_ET = "et";
DR.roadgames.GetWebRules.LANGUAGE_LT = "lt";
DR.roadgames.GetWebRules.LANGUAGE_RO = "ro";
DR.roadgames.GetWebRules.LANGUAGE_ES = "es";
DR.roadgames.GetWebRules.LANGUAGE_DE = "de";
DR.roadgames.GetWebRules.LANGUAGE_BG = "bg";
DR.roadgames.GetWebRules.LANGUAGE_PT = "pt";
DR.roadgames.GetWebRules.LANGUAGE_IT = "it";
DR.roadgames.GetWebRules.LANGUAGE_FR_BE = "fr_BE";
DR.roadgames.GetWebRules.LANGUAGE_PL = "pl";
DR.roadgames.GetWebRules.TYPE_RULES = "rules";
DR.roadgames.GetWebRules.TYPE_PRIVACY = "privacy";
DR.roadgames.GetWebRules.TYPE_COOKIES = "cookies";
DR.roadgames.GetWebRules[__P] = new DR._Method;
DR.roadgames.GetWebRules[__P][__C] = DR.roadgames.GetWebRules;
/** @type {String} */
DR.roadgames.GetWebRules.prototype.language = null;
/** @type {String} */
DR.roadgames.GetWebRules.prototype.type = null;
/** @type {DR.roadgames.struct.WebRules} */
DR.roadgames.GetWebRules.prototype.re = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.LatLngBounds = function(par){
	/** @private */
	this._t = 1372;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.east)) this.east = (parseFloat(par.east)||0);
	if(DR._Base.is(par.north)) this.north = (parseFloat(par.north)||0);
	if(DR._Base.is(par.south)) this.south = (parseFloat(par.south)||0);
	if(DR._Base.is(par.west)) this.west = (parseFloat(par.west)||0);
};
DR._Base._types[1372] = DR.roadgames.struct.LatLngBounds;
DR.roadgames.struct.LatLngBounds[__P] = new DR._Base;
DR.roadgames.struct.LatLngBounds[__P][__C] = DR.roadgames.struct.LatLngBounds;
/** @type {Number} */
DR.roadgames.struct.LatLngBounds.prototype.east = null;
/** @type {Number} */
DR.roadgames.struct.LatLngBounds.prototype.north = null;
/** @type {Number} */
DR.roadgames.struct.LatLngBounds.prototype.south = null;
/** @type {Number} */
DR.roadgames.struct.LatLngBounds.prototype.west = null;

/** @extends {DR._Base} */
DR.roadgames.struct.PicUploadRe = function(par){
	/** @private */
	this._t = 1024;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.error)) this.error = String(par.error||'');
	if(DR._Base.is(par.errorNr)) this.errorNr = (parseInt(par.errorNr)||0);
	if(DR._Base.is(par.pic)) this.pic = DR._Base.cast(par.pic);
};
DR._Base._types[1024] = DR.roadgames.struct.PicUploadRe;
DR.roadgames.struct.PicUploadRe[__P] = new DR._Base;
DR.roadgames.struct.PicUploadRe[__P][__C] = DR.roadgames.struct.PicUploadRe;
/** @type {String|null} */
DR.roadgames.struct.PicUploadRe.prototype.error = null;
/** @type {Number|null} */
DR.roadgames.struct.PicUploadRe.prototype.errorNr = null;
/** @type {DR.roadgames.struct.Pic|null} */
DR.roadgames.struct.PicUploadRe.prototype.pic = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.Question = function(par){
	/** @private */
	this._t = 1034;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.answer)) this.answer = (parseInt(par.answer)||0);
	if(DR._Base.is(par.answers)){
		var tmp = {};
		for( var k in par.answers ) tmp[k] = String(par.answers [k]||'');
		this.answers = tmp;
	}
	if(DR._Base.is(par.question)) this.question = String(par.question||'');
};
DR._Base._types[1034] = DR.roadgames.struct.Question;
DR.roadgames.struct.Question[__P] = new DR._Base;
DR.roadgames.struct.Question[__P][__C] = DR.roadgames.struct.Question;
/** @type {Number|null} */
DR.roadgames.struct.Question.prototype.answer = null;
/** @type {Object.<Number,String>} */
DR.roadgames.struct.Question.prototype.answers = null;
/** @type {String} */
DR.roadgames.struct.Question.prototype.question = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.Status = function(par){
	/** @private */
	this._t = 1046;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.error)) this.error = String(par.error||'');
	if(DR._Base.is(par.ok)) this.ok = Boolean(par.ok);
};
DR._Base._types[1046] = DR.roadgames.struct.Status;
DR.roadgames.struct.Status[__P] = new DR._Base;
DR.roadgames.struct.Status[__P][__C] = DR.roadgames.struct.Status;
/** @type {String|null} */
DR.roadgames.struct.Status.prototype.error = null;
/** @type {Boolean} */
DR.roadgames.struct.Status.prototype.ok = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.StreetViewPanorama = function(par){
	/** @private */
	this._t = 1280;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.heading)) this.heading = (parseFloat(par.heading)||0);
	if(DR._Base.is(par.panoramaId)) this.panoramaId = String(par.panoramaId||'');
	if(DR._Base.is(par.pitch)) this.pitch = (parseFloat(par.pitch)||0);
	if(DR._Base.is(par.zoom)) this.zoom = (parseFloat(par.zoom)||0);
};
DR._Base._types[1280] = DR.roadgames.struct.StreetViewPanorama;
DR.roadgames.struct.StreetViewPanorama[__P] = new DR._Base;
DR.roadgames.struct.StreetViewPanorama[__P][__C] = DR.roadgames.struct.StreetViewPanorama;
/** @type {Number} */
DR.roadgames.struct.StreetViewPanorama.prototype.heading = null;
/** @type {String} */
DR.roadgames.struct.StreetViewPanorama.prototype.panoramaId = null;
/** @type {Number} */
DR.roadgames.struct.StreetViewPanorama.prototype.pitch = null;
/** @type {Number} */
DR.roadgames.struct.StreetViewPanorama.prototype.zoom = null;
 
/** @extends {DR._Base} */
DR.roadgames.struct.VideoUploadRe = function(par){
	/** @private */
	this._t = 1040;
	if(!par || typeof par != 'object'){return;}
	if(DR._Base.is(par.error)) this.error = String(par.error||'');
	if(DR._Base.is(par.errorNr)) this.errorNr = (parseInt(par.errorNr)||0);
	if(DR._Base.is(par.video)) this.video = DR._Base.cast(par.video);
};
DR._Base._types[1040] = DR.roadgames.struct.VideoUploadRe;
DR.roadgames.struct.VideoUploadRe[__P] = new DR._Base;
DR.roadgames.struct.VideoUploadRe[__P][__C] = DR.roadgames.struct.VideoUploadRe;
/** @type {String|null} */
DR.roadgames.struct.VideoUploadRe.prototype.error = null;
/** @type {Number|null} */
DR.roadgames.struct.VideoUploadRe.prototype.errorNr = null;
/** @type {DR.roadgames.struct.Video|null} */
DR.roadgames.struct.VideoUploadRe.prototype.video = null;
 
D.loaded();